<template>
  <div class="creation-demand-step-number">
    <h2 class="step-title">
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@ERROR_TITLE")) }}
    </h2>
    <div class="creation-number-selection">
      {{ $t("ETAB.PAGES.DEMANDS.CREATION.@ERROR_LABEL") }}
    </div>
    <p class="text-center">
      <QBtn
        flat
        no-caps
        type="a"
        :href="`mailto:supportcandidats@extracadabra.com`"
        icon="fad fa-envelope"
        :label="$t('ETAB.BUTTONS.@CONTACT_US')"
        class="q-mx-auto"
      />
    </p>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss">
  .creation-demand-step-number {
    section {
      margin-left: 25px;
      margin-right: 25px;
    }
  }
</style>
